import { AddressFormats } from '../../../../../Enums/AddressFormats';

export const addressReducerTypes = {
  updateFieldValue: 'updateFieldValue',
  deleteCareOfFields: 'deleteCareOfFields',
  setInitialStateForAgent: 'setInitialStateForAgent',
  setInitialStateForTeam: 'setInitialStateForTeam',
  switchToCreateMode: 'switchToCreateMode',
  changeAddress: 'changeAddress',
  setNewAddress: 'setNewAddress',
  setSelectedAddress: 'setSelectedAddress',
  inheritAddressFromTeam: 'inheritAddressFromTeam',
  changeInheritance: 'changeInheritance',
  resetAddressState: 'resetAddressState',
  selectExistingAddress: 'selectExistingAddress',
  changeAddressFormat: 'changeAddressFormat',
  setAddressStateWhenError: 'setAddressStateWhenError',
  updateAgentAddressFromErrorView: 'updateAgentAddressFromErrorView',
  updateTeamAddressFromErrorView: 'updateTeamAddressFromErrorView',
  setNewState: 'setNewState',
};

export const addressReducer = (state, action) => {
  switch (action.type) {
    case addressReducerTypes.updateFieldValue: {
      return {
        ...state,
        address: {
          ...state.address,
          [action.propertyName]: action.value,
        },
      };
    }
    case addressReducerTypes.deleteCareOfFields: {
      const addressClone = { ...state.address };
      delete addressClone.careOf;
      return {
        ...state,
        address: {
          ...addressClone,
        },
      };
    }
    case addressReducerTypes.switchToCreateMode: {
      return {
        ...state,
        address: { country: action.country, format: state.address.format },
      };
    }
    case addressReducerTypes.changeAddress: {
      return {
        ...state,
        address: { ...state.address, ...action.address },
      };
    }
    case addressReducerTypes.setInitialStateForAgent: {
      return {
        uneditedData: {
          address: action.agentAddressDto.address,
          isInherited: action.agentAddressDto.inherited,
        },
        teamAddress: action.teamAddressDto.postalAddress,
        addressList: action.addressList,
        isInherited: action.agentAddressDto.inherited,
        address: action.agentAddressDto.address,
        errors: {},
        topViewButtonState: false,
      };
    }
    case addressReducerTypes.setInitialStateForTeam: {
      return {
        uneditedData: {
          address: action.teamAddressDto.postalAddress,
        },
        addressList: action.addressList,
        address: action.teamAddressDto.postalAddress,
        errors: {},
        topViewButtonState: false,
      };
    }
    case addressReducerTypes.setNewAddress: {
      if (action.isModalOpenedOnTeamLevel) {
        return {
          ...state,
          address: action.address,
          uneditedData: {
            address: action.address,
          },
          addressList: action.addressList,
        };
      }
      return {
        ...state,
        uneditedData: {
          address: action.address,
          isInherited: false,
        },
        addressList: action.addressList,
        isInherited: false,
        address: action.address,
      };
    }
    case addressReducerTypes.setSelectedAddress: {
      return {
        ...state,
        uneditedData: {
          address: state.address,
          isInherited: false,
        },
        topViewButtonState: false,
        isInherited: false,
        addressList: action.list,
      };
    }
    case addressReducerTypes.inheritAddressFromTeam: {
      return {
        ...state,
        address: state.teamAddress,
        uneditedData: { address: state.teamAddress, isInherited: true },
        topViewButtonState: false,
        isInherited: true,
        addressList: action.list,
      };
    }
    case addressReducerTypes.changeInheritance: {
      const topViewButtonState = state.uneditedData.isInherited ? state.isInherited : !state.isInherited;

      const newAddress = state.isInherited ? state.uneditedData.address : state.teamAddress;

      return {
        ...state,
        topViewButtonState,
        address: newAddress,
        isInherited: !state.isInherited,
      };
    }
    case addressReducerTypes.resetAddressState: {
      return {
        ...state,
        isInherited: state.uneditedData.isInherited,
        address: state.uneditedData.address,
        topViewButtonState: false,
      };
    }
    case addressReducerTypes.selectExistingAddress: {
      const address = state.addressList.find(x => x.id === action.addressId);

      const topViewButtonState = state.uneditedData.isInherited
        ? !state.isInherited
        : action.addressId !== state.uneditedData.address.id;

      return {
        ...state,
        topViewButtonState,
        address,
      };
    }
    case addressReducerTypes.changeAddressFormat: {
      return {
        ...state,
        address: { ...state.address, format: action.format },
      };
    }
    case addressReducerTypes.setAddressStateWhenError: {
      return {
        address: {
          format: AddressFormats.Street,
          country: action.countryList.find(x => x.code === action.legalUnit),
        },
        addressList: action.addressList ?? [],
        errors: {},
      };
    }
    case addressReducerTypes.updateAgentAddressFromErrorView: {
      return {
        ...state,
        uneditedData: {
          address: action.address,
          isInherited: false,
        },
        teamAddress: null,
        isInherited: false,
        address: action.address,
        errors: {},
        topViewButtonState: false,
      };
    }
    case addressReducerTypes.updateTeamAddressFromErrorView: {
      return {
        ...state,
        uneditedData: {
          address: action.address,
        },
        address: action.address,
        errors: {},
        topViewButtonState: false,
      };
    }
    case addressReducerTypes.setNewState: {
      return {
        ...action.newState,
      };
    }
    default: {
      throw Error('Unknown action.', action);
    }
  }
};
